import * as React from "react";
import { Download } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";
import * as analytics from "@/services/analytics";

interface Props {
  snapshotCollection: SnapshotCollection;
}

export const SnapshotCollectionsOutcomesExport: React.FC<Props> = ({ snapshotCollection }) => {
  const handleClick = (url: string) => () => {
    analytics.snapshotCollectionExport(snapshotCollection.name);
    document.location.href = url;
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="default" className="rounded bg-primary px-4 py-2 text-white">
          <Download className="mr-2 h-5 w-5" />
          Export SnapShots
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={handleClick(
            `/pf-business-reports/business-report-outcome/export?business_report_id=${snapshotCollection.business_report_id}&format=xlsx`,
          )}
          className="cursor-pointer"
        >
          Export all collections to XLS
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={handleClick(
            `/pf-business-reports/business-report-outcome/export?snapshot_collection_id=${snapshotCollection.id}&business_report_id=${snapshotCollection.business_report_id}&format=xlsx`,
          )}
          className="cursor-pointer"
        >
          Export "{snapshotCollection.name}" to XLS
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
